import "./Modal.css";
import api from "../../api/axiosConfig";
import React, { useState, useEffect, useRef } from "react";
import emailjs, { send } from '@emailjs/browser';

function Modal({employeeEmail, month, year, employeeDetails, modalOpen, setModalOpen, previewStatus, selectedDate}) {
  const FormData = require('form-data')
  const formData = new FormData()
  var [timesheets, setTimesheets] = useState();
  var [photos, setPhotos] = useState([]);
  var [photoOIDs, setPhotoOIDs] = useState([]);
  const [message, setMessage] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [overtime, setOvertime] = useState(false);
  const [isNew, setIsNew] = useState(true);
  var approverName = " ";
  var approverEmail = " ";
  var sheets = [];
  var genDays = [];
  var genDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
  const mgrName = useRef();
  const mgrEmail = useRef();

  year = year.toString();
    
  const form = useRef();

  const generateFillers = () => {
    while (genDate.getMonth() === selectedDate.getMonth()) {
      genDays.push(new Date(genDate));
      genDate.setDate(genDate.getDate() + 1);
    }
    for (let i = 0; i < genDays.length; i++ ) {
      let fillDate = genDays[i].toString().substring(0, 15);
      if(fillDate.substring(0,3) != "Sat" && fillDate.substring(0,3) != "Sun" ){
          var fillData = {
            employeeEmail: employeeEmail,
            month: month,
            year: year,
            date: fillDate,
            dayType: 'Regular Workday',
            hoursWorked: '8',
            hoursOvertime: '0'
          }
            sheets.push(fillData);   
      }
    } 
  } 
  useEffect(() => {
    generateFillers();
  },[modalOpen])

  const checkStatus = async () => {
    try{
      const token = await api.get('/request/check/' + employeeEmail + "/" + month + "/" + year);
      console.log(token.data.response);
      if(token.data.response==='approved'){
        alert("This timesheet has already been approved")
        console.log('already approved')
        setIsNew(false)
      }
    }catch(err){
      console.log(err)
    }
  }


  


  const getTimesheets = async() =>{
    try{     
      const responseSheets = await api.get('/sheets/'+ employeeEmail + "/" + month +"/" + year);
      for(let j = 0; j < responseSheets.data.length; j++){
        if(sheets.find(sheet => sheet.date === responseSheets.data[j].date)){
          for(let i = 0; i < sheets.length; i++){
            if(sheets[i].date===responseSheets.data[j].date){
              sheets[i].dayType = responseSheets.data[j].dayType;
              sheets[i].hoursWorked = responseSheets.data[j].hoursWorked;
              sheets[i].hoursOvertime = responseSheets.data[j].hoursOvertime;
              console.log(sheets[i])
            }
          }
        }
      }
      setTimesheets(sheets);
      var allOvertimeHours = responseSheets.data.map(row => JSON.parse(row.hoursOvertime))
      var totalOvertimeHours = 0;
      for (let i = 0; i < allOvertimeHours.length; i++ ) {
        totalOvertimeHours += allOvertimeHours[i];
      }
      if(0 < totalOvertimeHours){
        setOvertime(true);
        alert("Please upload your Overtime Approval in JPEG or PNG.");
      }
      
    }catch(err){
      console.log(err)
    }
    console.log(timesheets)
}
useEffect(() => {
  getTimesheets();
  console.log(timesheets);
},[modalOpen])

  const closeModal = () => {
    timesheets = null;
    setMessage(null);
    setModalOpen(false)
    setIsValid(true)
    setOvertime(false)
    setIsNew(true)
  }
  const [img, setImage] = useState('');
  const handleImage = (e) =>{
    console.log(e.target.files)
    setImage(e.target.files[0])
  }

  const uploadHandler = async (e) =>{
    e.preventDefault()
    formData.append('employeeEmail', employeeEmail)
    formData.append('month', month)
    formData.append('year', year)
    formData.append('img', img)
    

    if(img) {
      try{
        const response = await api.post('/photos/add', formData);
        console.log(response.data)
        if(response.status = 200){
          setIsValid(true);
        }
      }catch(err){
        alert("Please select photo to upload");
        console.error(err)
      };
    }
    else{
      alert('No image selected!');
    }
    getPhotos();
  }  

  const getMessage = () => {
    let base = "http://timesheet.isphereiq.com/approval/";
    let key = employeeDetails.data.employeeName.split(' ').map(function(item){return item[0]}).join('')+Date.now();
    setMessage(base + key + "/" + employeeEmail + "/" + month + "/" + year)
    console.log(key)    
  }
  useEffect(() => {
    if(modalOpen){
        getMessage();
    }
  }, [])
  
  const sendEmail = async(e) => {
    e.preventDefault();
    console.log("noPhotosCheck");
    let response = "for approval";
    let reqData = new FormData();
    approverName = mgrName.current.value;
    approverEmail = mgrEmail.current.value;
    console.log(approverName + approverEmail)
    reqData.append('managerName', approverName);
    reqData.append('managerEmail', approverEmail);
    let key = message.substring(40,55);
    const res = await api.post('/request/save/' + key +  "/" + 'for approval' + "/" + employeeEmail + "/" + month + "/" + year, reqData); 
    
    for(let j = 0; j < timesheets.length; j++){
      try{
        let data = {
          date: timesheets[j].date,
          dayType: timesheets[j].dayType,
          hoursWorked: timesheets[j].hoursWorked,
          hoursOvertime: timesheets[j].hoursOvertime
        }
        const response = await api.post('/sheets/save/'+ employeeEmail + "/" + month + "/" + year, data);
        console.log(data)
        console.log(response)
      }catch(err){
        console.error(err)
      }
    }
    
    emailjs.sendForm('service_hc4879t', 'template_desbxoy', form.current, '_Nxdpscq-t21WlkV6')
      .then((result) => {
          
          console.log(result.text);
          alert("Your Timesheet has been submitted!")
          window.location.reload();
      }, (error) => {
          console.log(error.text);
      });
      console.log(res)
  };

  let checkPhoto = [];
  const getPhotos = async() =>{
    try{      
      const response = await api.get('/photos/'+ employeeEmail + "/" + month +"/" + year);
      setPhotos(response.data.photoList, () =>{
        checkPhoto = response.data.photoList;
        if(checkPhoto.length()== 0){
          setIsValid(false);
        }else{
          setIsValid(true);
        }
      })
      setPhotoOIDs(response.data.oidList)
      console.log(response.data.oidList)
    }catch(err){
      console.log(err)
    }
  }
  useEffect(() => {
    getPhotos();
  },[modalOpen])

  const deletePhoto = async(img) =>{
    var toDelete = photoOIDs[img];
    setPhotos(photos.filter((photo, index)=>index !== img));
    setPhotoOIDs(photoOIDs.filter((photo, index)=>index !== img));
    try{
      const response = await api.delete('/photos/delete/'+ toDelete);
      console.log(response.data)
    }catch(err){
      console.log(err)
    }

  }  

  // const setManagerEmail= (e) => {
  //   approverEmail = e.target.value;
  //   console.log(approverEmail);
  // }

  // const setManagerName = (e) => {
  //   approverName = e.target.value;
  // }  

  const checkValidity = () => {
    if(overtime&&photos.length ==0){
      console.log("checkValidity fail");
      console.log(overtime)
      console.log(photos.length)
      setIsValid(false);
    }else{
      console.log("checkValidity pass");
      console.log(overtime)
      console.log(photos.length)
      setIsValid(true);
    }
  }

  useEffect(() => {
    checkValidity();  
  },[modalOpen, photos, timesheets])


  


console.log(isValid)
  return (
  <div>
  {previewStatus&&(
    <button className="genBtn" onClick={() => {
      setModalOpen(true), getTimesheets(), getPhotos(), checkStatus(), getMessage(), checkValidity(), generateFillers();
    }}>PREVIEW TIMESHEET</button>)}
    <div className="modalForm">
     {modalOpen &&(
      <div className="modalBackground">
        <form ref = {form} onSubmit={sendEmail}> 
        <div className="modalContainer">
          <div className="fillContainer">
          <button type="button" onClick={() => {closeModal()}} class="btn-close" aria-label="Close"></button>
          </div>
          <table className="modalHeader">
            <tr>
              <td>
                <h3 className="monthYearDisplay">{ month } { year }</h3> 
              </td>
              <td className="modalEmpDtls">
              <tbody>
                  <h6 className="modalEmpTr">
                    Employee: {employeeDetails.data.employeeName}
                  </h6>
                  <h6 className="modalEmpTr">
                    Client: {employeeDetails.data.client}
                  </h6>
                  <h6 className="modalEmpTr">
                    Location: {employeeDetails.data.clientLocation}
                  </h6>
                  <h6 className="modalEmpTr">
                    Project: {employeeDetails.data.project}
                  </h6>
                </tbody>
              </td>
            </tr>
          </table>  
          <table className="modalTbl">
            <thead>
              <tr>
                <th>DATE</th>
                <th>DAY TYPE</th>
                <th>HOURS WORKED</th>
                <th>OVERTIME HOURS</th>
              </tr>
            </thead>
              <tbody className="body">
                {
                  timesheets.map((user, index) => {
                    return <tr key={index}>
                      <td>{user.date}</td>
                      <td>{user.dayType}</td>
                      <td>{user.hoursWorked}</td>
                      <td>{user.hoursOvertime}</td>
                    </tr>
                  })
                }
              </tbody>
          </table>
          <div className = "mgrDtlContainer">
            <hr class="solid"/>
            <p className="modalDivLabel">Approver Details</p>
            <input type="email" className = "mgrDtl" placeholder="Manager's Email" name="managerEmail" required={true} ref={mgrEmail} />   
            <input type="text" className="mgrDtl" placeholder="Manager's Name" name="managerName" required={true} ref={mgrName} />   
            <hr class="solid"/>
            <p className="modalDivLabel">Proof of Overtime Approval</p>   
            <input type="file" onChange={handleImage} className="selFile" data-maxfilesize="2" accept="image/png, image/jpeg"/>
            <button type="button" onClick={(e) => uploadHandler(e)} className="uploadBtn">Upload</button>
          </div>
          <div>
            {
              photos.map((user, index) =>    
                <div>          
                  <img className='photos' width='85%' height='fit-content' src={'data:image/png;base64,'+user} key={index} />
                  <button type="button" className="delPhoto" onClick={() => deletePhoto(index)}>delete</button>
                </div>
                )
            }
          </div>
          <div className="footer">
            <button
              onClick={() => {
                closeModal()
              }}
              id="cancelBtn"
            >
              Cancel
            </button>
            <input type="hidden" className="form-control" name="managerEmail" value={approverEmail}/>   
            <input type="hidden"className="form-control" name="managerName" value={approverName}/> 
            <input type="hidden" className="form-control" name="employeeEmail" value={employeeEmail} />
            <input type="hidden" className="form-control" name="message" value={message} />
            {isValid && isNew &&(
            <input type="submit" value="Submit" className="submitBtn" />)}
          </div>
        </div> 
      </form>
      </div>)}
    </div> 
    </div>             
  )
};

export default Modal;